/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { Redirect } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import { sessionstore, StorageKeys, authToken, deepLink } from '../../../utilities/LocalStorage';
import ManageSession from '../../../utilities/ManageSession';
import SessionModel from '../../../models/SessionModel';

import Layout from '../../applicationFrame/Layout';
import MfaLogin from '../../appUnauthorized/presenters/MfaLogin.redux';
import Intro from '../../appUnauthorized/intro/Intro';
import GroupJoinInstructionsUnauthorized from '../../appUnauthorized/presenters/GroupJoinInstructions/GroupJoinInstructionsUnauthorized.redux';
import Login from '../../appUnauthorized/presenters/Login.redux';
import ForgotPassword from '../../appUnauthorized/presenters/ForgotPassword.redux';
import TokenViews from '../../appUnauthorized/presenters/TokenViews.controller';
import CheckYourInbox from '../../appUnauthorized/views/CheckYourInbox';
import UserSignup from '../../appUnauthorized/presenters/UserSignup.controller';
import CustomerService from '../../../utilities/CustomerService';
import PrivacyIntroForNewSignup from '../../appUnauthorized/views/PrivacyIntro/PrivacyIntroForNewSignup';
import RedirectToBackpackRoute from '../../components/RedirectToBackpackRoute';
import { useLists } from '../../hooks/useLists';
import { useUser } from '../../hooks/useUser';
import { useAndroidInitialization } from '../../hooks/useAndroid';

const ViewsWithoutSavedToken = (props) => {
  switch (sessionstore.get(StorageKeys.TOKEN_TYPE)) {
    case 'mfa':
      return <Redirect to="/verify" />;
    default:
      return props.children;
  }
};

const OtherUrl = () => {
  const [state, setState] = React.useState(false)
  React.useEffect(() => {
    deepLink.set(window.location.pathname);
    setState(true);
  }, []);

  return state ? <Redirect to="/" /> : null;
};

interface Props {
  store: any;
}
const UnAuthenticatedApp = (props: Props) => {
  const [{ isLoaded }, listActions] = useLists();
  const [, userActions] = useUser();

  React.useEffect(() => {
    const token = authToken.get();
    CustomerService.initAnonymous();

    if (token) {
      const session = new SessionModel(authToken.decode());
      ManageSession.start(session, props.store);
    }
  } , []);

  React.useEffect(() => {
    if (!isLoaded) { return; }

    const locale = listActions.getClosestMatchingLocale();
    userActions.setClientLocale(locale);
  }, [isLoaded]);

  useAndroidInitialization(null);

  return (
    <Layout>
      <Switch>
        <Route path="/intro" component={Intro} />
        <Route exact path="/verify" component={MfaLogin} />
        <RedirectToBackpackRoute>
          <ViewsWithoutSavedToken>
            <Switch>
              <Route path="/signup/intro" component={PrivacyIntroForNewSignup} />
              <Route path="/signup" component={UserSignup} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/loginpassword" component={Login} />
              <Route exact path="/forgotpassword" component={ForgotPassword} />
              <Route exact path="/forgotpassword/checkinbox">
                <CheckYourInbox
                  title="forgotPwdCheckInbox.title.text"
                  notification="forgotPwdCheckInbox.notification.message.text"
                />
              </Route>
              <Route exact path="/token/:token" component={TokenViews} />
              <Route exact path="/join/:group" component={GroupJoinInstructionsUnauthorized} />

              <Route exact path="/" component={Login} />
              <OtherUrl />
            </Switch>
          </ViewsWithoutSavedToken>
        </RedirectToBackpackRoute>
      </Switch>
    </Layout>
  );
};

export default UnAuthenticatedApp;
